/**
 * @generated SignedSource<<835167eb9e9c5e6c8779d56774bc3149>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type InspectionStateEnum = "APPROVED" | "ASSIGNED" | "IN_PROGRESS" | "PLANNED" | "REJECTED" | "RETRY" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type InspectionReportOverview$data = {
  readonly inspections: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly approvedDate: any | null;
        readonly id: string;
        readonly rejectedDate: any | null;
        readonly retryDate: any | null;
        readonly state: InspectionStateEnum | null;
        readonly " $fragmentSpreads": FragmentRefs<"InspectionReportCard">;
      } | null;
    } | null>;
  };
  readonly " $fragmentType": "InspectionReportOverview";
};
export type InspectionReportOverview$key = {
  readonly " $data"?: InspectionReportOverview$data;
  readonly " $fragmentSpreads": FragmentRefs<"InspectionReportOverview">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InspectionReportOverview",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "InspectionNodeConnection",
      "kind": "LinkedField",
      "name": "inspections",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "InspectionNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "InspectionNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "approvedDate",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "rejectedDate",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "retryDate",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "InspectionReportCard"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "state",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "InspectionfieldNode",
  "abstractKey": null
};

(node as any).hash = "5bc9260845663859a740efcf8681ffd8";

export default node;
